import React, { useState, useEffect, memo } from "react"
import { Tooltip } from "antd"
import "./InvestigatorComparator.scss"
const InvestigatorComprator = (props) => {
  const { value, data } = props
  const { headerName } = props.colDef
  const [display, setDisplay] = useState(null)

  useEffect(() => {
    let source = data.location_data.source
    let mask = data.location_data.mask
    let ctg = data.location_data.ctg

    let sourceVal = null
    let ctgVal = null
    let maskVal = null

    if (source && source.investigator) {
      let contact = findContactRole(source.investigator)
      if (contact) {
        sourceVal = formatContact(contact)
      }
    }
    if (ctg && ctg.investigator) {
      let contact = findContactRole(ctg.investigator)
      if (contact) {
        ctgVal = formatContact(contact)
      }
    }
    if (mask && mask.investigator) {
      let contact = findContactRole(mask.investigator)
      if (contact) {
        maskVal = formatContact(contact)
      }
    }

    let component = processValues(sourceVal, ctgVal, maskVal)
    setDisplay(component)
  }, [value, data])

  const findContactRole = (investigators) => {
    let arr = []
    if (!Array.isArray(investigators)) arr = [investigators]
    else arr = investigators

    if (arr && arr.length > 0) {
      let person = arr.filter((person) => person?.role?.includes(headerName))
      if (person.length > 0) return person[0]
    }
    return null
  }

  const formatContact = ({ first_name = "", middle_name = "", last_name = "", degrees = "" }) => {
    let fullName = [first_name, middle_name, last_name]
      .filter((item) => item && item.length > 0)
      .join(" ")
      .trim()
    let fullNameDegree = [fullName, degrees]
      .filter((item) => item && item.length > 0)
      .join(", ")
      .trim()

    return fullNameDegree
  }

  const processValues = (source, ctg, mask) => {
    if (mask !== undefined && mask !== null && ctg) {
      // if MASK + CTG data is available
      if (mask == ctg) {
        // if MASK + CTG data is equal
        return getComponent(
          mask,
          "masked",
          "Value Overriden Source Value: " + source + "; MASK value = CTG value",
          true
        )
      } else {
        // if MASK + CTG data is NOT equal
        let maskComponent = getComponent(mask, "masked", "Value Overriden Source Value: " + source, true)
        let ctgComponent = getComponent(ctg, "ctg-only", "CTG value")
        return [maskComponent, ctgComponent]
      }
    } else if (mask !== undefined && mask !== null) {
      // only MASK data
      return getComponent(mask, "masked", "Value Overriden Source Value: " + source, true)
    } else if (ctg && source) {
      // if Source + CTG data is available
      if (ctg == source) {
        // if Source + CTG data is equal
        return getComponent(source, "equal", "Prime value = CTG value")
      } else {
        // if Source + CTG data is NOT equal
        let sourceComponent = getComponent(source, "source-only", "Prime value")
        let ctgComponent = getComponent(ctg, "ctg-only", "CTG Value")
        return [sourceComponent, ctgComponent]
      }
    } else if (source) {
      // if Source data only
      return getComponent(source, "source-only", "Prime value")
    } else if (ctg) {
      // if CTG data only
      return getComponent(ctg, "ctg-only", "CTG Value")
    }
    return null
  }

  const getComponent = (value = "", type, tooltip, showMask = false) => {
    const getColor = (type) => {
      switch (type) {
        case "ctg-only":
          return "address-comparator-ctg-only"
        case "source-only":
          return "address-comparator-source-only"
        case "masked":
          return "address-comparator-masked"
        default:
          return "address-comparator-default"
      }
    }
    const getTextDecoration = (type) => {
      if (type === "ctg-only") return "ctg-only-text-decoration"
      return "default"
    }

    return (
      <Tooltip title={<div className="investigator-comparator-info-container">{tooltip}</div>}>
        <div
          type={type}
          className={`${getColor(props.type)} ${getTextDecoration(props.type)} investigator-comparator-text`}
        >
          {showMask && <div className="fas fa-eye investigator-comparator-mask" />}
          {value}
        </div>
      </Tooltip>
    )
  }

  return <div className="investigator-comparator-container">{display}</div>
}

export default memo(InvestigatorComprator)
